module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui stackable three cards"
  }, _vm._l((_vm.goods), function(item) {
    return _c('div', {
      staticClass: "ui fluid card"
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/good/' + item.id)
        }
      }
    }, [(item.images[0]) ? _c('img', {
      staticClass: "ui centered image",
      attrs: {
        "src": item.images[0].url
      }
    }) : _c('img', {
      staticClass: "ui centered image",
      attrs: {
        "src": 'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/' + item.id + '.jpg'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('router-link', {
      staticClass: "header",
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "to": '/good/' + item.id
      }
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('div', {
      staticClass: "ui tag labels"
    }, [_c('a', {
      staticClass: "ui custom_brown label"
    }, [_vm._v("\n                Cena: " + _vm._s(_vm.realPrice(item)) + " €\n              ")]), _vm._v(" "), (item.bail > 0) ? _c('a', {
      staticClass: "ui green label"
    }, [_vm._v("\n                Drošības nauda: " + _vm._s(item.bail) + " €\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n              " + _vm._s(item.description) + "\n            ")])], 1), _vm._v(" "), (!_vm.checkIfInCart(item)) ? _c('button', {
      staticClass: "ui bottom attached button",
      on: {
        "click": function($event) {
          return _vm.addItemToCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    }), _vm._v(" Pievienot\n          ")]) : _c('div', {
      staticClass: "ui three bottom attached  buttons"
    }, [_c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.reduceItemInCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "minus icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'cart'
          })
        }
      }
    }, [_c('i', {
      staticClass: "cart icon"
    }), _vm._v(" " + _vm._s(_vm.howManyInCart(item)) + " gab.\n           ")]), _vm._v(" "), _c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.addItemToCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    })])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "thumbs up icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Iesakām\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed0003d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewGoodsPage.vue
// module id = 367
// module chunks = 1